import axios from 'axios';
import authService from './authService';

const API_URL = '/user/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class UserService {
  getUserProfile() {
    return axios.get(API_URL + 'profile');
  }

  updateUserProfile(profileData) {
    return axios.put(API_URL + 'profile', profileData);
  }

  deleteAccount() {
    return axios.delete(API_URL + 'account');
  }

  changePassword(passwordData) {
    return axios.put(API_URL + 'change-password', passwordData);
  }
}

export default new UserService();